import React from 'react'
import {Table, Form} from '@q4us-sw/q4us-ui'
import moment from 'moment';
import {
    getFeConfig,
    visualizeWithFilters,
    visualizeorderbreakdown,
    visualizeordersplits,
    visualizesplitbreakdown,
    visualizeordershipments,
    visualizeshipmentbreakdown,
    visualizeCustomsForm,
    visualizeCustomsDeclaration,
    testUpdateFCCDate,
    testVerifyPayment,
    testUpdateShipmentTimestamp,
    visualizeQR,
    visualizeBarcode,
    completeInvoice, visualizeLoad, testUpdatePostSalePaymentDate
} from "../api/api";
import {Modal, Button, Space, notification, Typography, DatePicker, Divider, Input} from 'antd';
import TableDataSource from "../utils/TableDataSource";
import QRCode from 'qrcode';
import {MapToFilter} from "../utils/mappings";
import {TableV2} from "@q4us-sw/q4us-ui/lib/TableV2";
import {TableFilter} from "./filters/TableFilter";
import {AppstoreAddOutlined, DropboxOutlined} from "@ant-design/icons";
import {Header} from "./generic/Header";

export const showCustomsForm = async (shipment_id, formType)=>{
    const {data} = await visualizeCustomsForm(shipment_id, formType) || {};
    if (data) {
        const blobStore = new Blob([data], {type: 'application/pdf'});
        const url = window.URL.createObjectURL(blobStore);
        let params = `scrollbars=no,resizable=no,status=no,location=no,toolbar=no,menubar=no`;
        window.open(url, `${shipment_id}.pdf`, params);
    }
};

export const showCustomsDeclaration = async (shipment_id)=>{
    const {data} = await visualizeCustomsDeclaration(shipment_id) || {};
    if (data) {
        const blobStore = new Blob([data], {type: 'text/xml'});
        const url = window.URL.createObjectURL(blobStore);
        let params = `scrollbars=no,resizable=no,status=no,location=no,toolbar=no,menubar=no`;
        window.open(url, `${shipment_id}.xml`, params);
    }
};

export const showQrCode = async (shipment_id)=>{
    const {data} = await visualizeQR(shipment_id) || {};
    if (data) {
        const blobStore = new Blob([data], {type: 'image/png;'});
        const url = window.URL.createObjectURL(blobStore);
        const img = new Image()
        img.src= url;
        console.log(img.outerHTML)
        const params = `scrollbars=no,resizable=no,status=no,location=no,toolbar=no,menubar=no,top=350,left=700,width=350,height=350`;
        const html = `<body style="background-color:white;"> ${img.outerHTML} </body>`
        let w = window.open("", `${shipment_id}-qr.png`, params);
        w.document.write(html);
    }
};

export const showBarcode = async (shipment_id)=>{
    const {data} = await visualizeBarcode(shipment_id) || {};
    if (data) {
        const blobStore = new Blob([data], {type: 'image/png;'});
        const url = window.URL.createObjectURL(blobStore);
        const img = new Image()
        img.src= url;
        console.log(img.outerHTML)
        const params = `scrollbars=no,resizable=no,status=no,location=no,toolbar=no,menubar=no,top=350,left=700,width=350,height=350`;
        const html = `<body style="background-color:white;"> ${img.outerHTML} </body>`
        let w = window.open("", `${shipment_id}-barcode.png`, params);
        w.document.write(html);
    }
};

export const Items = ({orderId,splitId,shipmentId})=> {
    const [source] = React.useState(new TableDataSource());
    return <Table
        key={`${orderId}.${splitId}.${shipmentId}`}
        fetchConfig={async ()=>{
            const { data = {} } = await getFeConfig('order_breakdown')
            const {rows = []} = data;

            const hs6pApplicable = rows.find(row => row.name === 'hs6p_applicable');
            const hs6pReceived = rows.find(row => row.name === 'hs6p_received');
            if (hs6pApplicable) {
                hs6pApplicable.formatter = (row, index, name, type, formatted, value) =>{
                    return value ? `${value}`.replace(/^(\d{4})(\d{2})/g, '$1 $2 ') : '';
                };
            }
            if (hs6pReceived) {
                hs6pReceived.formatter = (row, index, name, type, formatted, value) =>{
                    return value ? `${value}`.replace(/^(\d{4})(\d{2})/g, '$1 $2 ') : '';
                };
            }
            return {data};
        }}
        fetchData={async ()=>{
            if(splitId)
                return await visualizesplitbreakdown(splitId)
            if(shipmentId)
                return await visualizeshipmentbreakdown(shipmentId)
            else
                return await visualizeorderbreakdown(orderId)
        }}
        scroll={{y: 'calc(60vh - 20px)', x: 'max-content' }}
        saveData={async (data) => {
            return { data: { statusCode:200, rows: [data] } };
        }}
        source={source}
    />
}

export const Splits = ({orderId})=> {
    const [splitId, setSplitId] = React.useState(undefined)
    const [source] = React.useState(new TableDataSource());
    return <React.Fragment>
        <Table
            key={orderId}
            fetchConfig={async ()=>{
                const {data= {}} = await getFeConfig("order_splits")
                const { statusCode, rows = [], fields = [] } = data;

                rows.unshift({
                    dataIndex: "split_id", title: "Items", width: 120, formatter: (row, index, name, type, formatted, value) => {
                        return <Space key={index}>
                            <Button onClick={()=>{
                                setSplitId(value)
                            }}>Items</Button>
                        </Space>;
                    }
                })
                return {data:{statusCode, rows, fields}};
            }}
            fetchData={async ()=>{
                return await visualizeordersplits(orderId)
            }}
            scroll={{y: 'calc(60vh - 20px)', x: 'max-content' }}
            saveData={async (data) => {
                return { data: { statusCode:200, rows: [data] } };
            }}
            source={source}
        />
        <Modal title={`Order #${orderId} Split #${splitId}`}
               width="80vw"
               visible={splitId != null}
               closable={true}
               key={splitId}
               footer={null}
               onCancel={()=>{
                   setSplitId(undefined)
               }}
        >
            {splitId && <Items key={splitId} orderId={orderId} splitId={splitId}/>}
        </Modal>
    </React.Fragment>
}

export const Shipment = ({orderId})=> {
    const [shipmentId, setShipmentId] = React.useState(undefined)
    const [source] = React.useState(new TableDataSource());

    const [timestampModal, setTimestampModal] = React.useState({
        id:'',
        visible:false,
        timestamp: moment().subtract(1, "months")
    });

    return <React.Fragment>
        <Table
            key={orderId}
            fetchConfig={async ()=>{
                const {data= {}} = await getFeConfig("order_shipment_view")
                const { statusCode, rows = [], fields = [] } = data;

                rows.unshift({
                    dataIndex: "shipment_id", title: "Items", width: 120, formatter: (row, index, name, type, formatted, value) => {
                        return <Space key={index}>
                            <Button onClick={()=>{
                                setShipmentId(value)
                            }}>Items</Button>
                        </Space>;
                    }
                },
                {
                    dataIndex: "shipment_id", title: "Customs Forms", width: 200, formatter: (row, index, name, type, formatted, value) => {
                        const {shipment_id, order_id, order_status, cn_report_type, customs_dec_scheme, calculated_threshod} = row;
                        const isEnabled = ((order_status === "payment_verified") && cn_report_type && (cn_report_type !== 'none'));
                        const reportName = cn_report_type ? cn_report_type.toUpperCase() : null;
                        const declaration = customHReportType(customs_dec_scheme);
                        const isDeclarationEnabled = (declaration !== null && order_status === "payment_verified");
                        return <Space key={index}>
                            <Button disabled={!isEnabled} onClick={()=>{
                                showCustomsForm(shipment_id, cn_report_type);
                            }}>{reportName}</Button>
                            <Button disabled={!isDeclarationEnabled} onClick={()=>{
                                showCustomsDeclaration(shipment_id);
                            }}>{declaration}</Button>
                        </Space>;
                    }
                },
                {
                    dataIndex: "shipment_id", title: "QR code", width: 120, formatter: (row, index, name, type, formatted, value) => {
                        const {shipment_id, order_status} = row;
                        const isPaymentVerified = (order_status === "payment_verified");
                        return <Space key={index}>
                            <Button disabled={!isPaymentVerified} onClick={()=>{
                                showQrCode(shipment_id);
                            }}>QR Code</Button>
                        </Space>;
                    }
                },
                    {
                        dataIndex: "shipment_id", title: "Barcode", width: 120, formatter: (row, index, name, type, formatted, value) => {
                            const {shipment_id, order_status} = row;
                            const isPaymentVerified = (order_status === "payment_verified");
                            return <Space key={index}>
                                <Button disabled={!isPaymentVerified} onClick={()=>{
                                    showBarcode(shipment_id);
                                }}>Barcode</Button>
                            </Space>;
                        }
                    }
                )

                const {REACT_APP_DEMO_MODE = undefined} = process.env;
                if (REACT_APP_DEMO_MODE) {
                    rows.unshift({
                        name: "id",
                        title: "Test Actions",
                        width: 140,
                        formatter: (row, index, name, type, formatted, value) => {
                            const {shipment_id} = row;
                            return <Button onClick={()=>{
                                setTimestampModal({
                                    id:`${shipment_id}`,
                                    visible: true,
                                    timestamp: moment().subtract(1, "months")
                                })
                            }}>Update Timestamp</Button>
                        }
                    })
                }

                return {data:{statusCode, rows, fields}};
            }}
            fetchData={async ()=>{
                return await visualizeordershipments(orderId)
            }}
            scroll={{y: 'calc(60vh - 20px)', x: 'max-content' }}
            saveData={async (data) => {
                return { data: { statusCode:200, rows: [data] } };
            }}
            source={source}
        />
        <Modal title={`Order #${orderId} Shipment #${shipmentId}`}
               width="80vw"
               visible={shipmentId != null}
               closable={true}
               key={shipmentId}
               footer={null}
               onCancel={()=>{
                   setShipmentId(undefined)
               }}
        >
            {shipmentId && <Items key={shipmentId} orderId={orderId} shipmentId={shipmentId}/>}
        </Modal>

        <Modal
            key={`${setTimestampModal.visible}`}
            centered={true}
            closable={true}
            onCancel={()=>setTimestampModal({
                id: '',
                visible: false,
                timestamp: moment().subtract(1, "months")
            })}
            visible={timestampModal.visible}
            title={`Update Shipment #${timestampModal.id}`}
            onOk={async ()=>{
                const {visible, ...args} = timestampModal;
                const {status} = await testUpdateShipmentTimestamp({...args});
                if (status === 200) {
                    notification.success({message: `Shipment #${timestampModal.id} timestamp updated`});
                } else {
                    notification.error({message: `Error updating Shipment #${timestampModal.id} timestamp`});
                }
                setTimestampModal({
                    id:'',
                    visible:false,
                    timestamp: moment().subtract(1, "months")
                })
            }}
        >
            <table>
                <tr style={{paddingBottom: 10}}>
                    <td style={{padding: 12}}><Typography.Text>Shipment Timestamp</Typography.Text></td>
                    <td style={{padding: 12}}><DatePicker value={timestampModal.payment_verified_date} onChange={(date)=>{
                        setTimestampModal({...timestampModal, timestamp: date})
                    }}/></td>
                </tr>
            </table>
        </Modal>

    </React.Fragment>
}

const ModalType = Object.freeze({
    None: 0,
    Items: 1,
    Splits: 2,
    Shipments: 3
})

const customHReportType = (custom_dec)=> {
    if(custom_dec){
        if (custom_dec === 'IOSS-IMPORT' ||
            custom_dec === 'FC-SIMPLE-REP' ||
            custom_dec === 'FC-REP' ||
            custom_dec === 'B2B-INTRA-COMMUNAL') {
            return 'Declaration';
        }
    }
    return null
};

const OrderDiscountItems = (props) => {
    const [source, setSource] = React.useState(new TableDataSource());

    const fetchData = async (values, page = {})=>{
        return await visualizeLoad({
            tableName: 'dashboard_order_discount_breakdown_view',
            orderBy: ['discount_id desc, timestamp_year desc'],
            filter:[{name: 'order_id', value: props.order_id}, {name: 'timestamp_year', value: props.timestamp_year}],
            page: { size: page.size || 100, from: ((page.current || 1) - 1) * (page.size || 100)}
        }) || {}
    }

    return <Space direction={`vertical`} style={{width: '100%'}}>
        <TableV2
            fetchConfig={async () => {
                const {data= {}} = await getFeConfig('dashboard_order_discount_breakdown_view')
                const { statusCode, rows = [], fields = [] } = data;
                return { data: { statusCode, rows, fields } };
            }}

            scroll={{y: 'calc(90vh - 40px)', x: 'max-content' }}
            fetchData={async (request) => {
                return await fetchData(request.options.filter || {}, request.page)
            }}

            editable={false}
            source={source}
        />
    </Space>
}

export const OrderInfo = (props) => {

    const [opt,setOpt] = React.useState({type: ModalType.None, orderId: undefined})

    const fetchData = async (values, page = {})=>{
        const filters = MapToFilter(values)
        return await visualizeLoad({
            tableName: 'order_info_view_with_s10',
            orderBy: ['id desc'],
            filter:[...filters],
            page: { size: page.size || 100, from: ((page.current || 1) - 1) * (page.size || 100)}
        }) || {}
    }

    const [paid, setPaid] = React.useState({
        id:'',
        visible:false,
        payment_verified_date: moment().subtract(1, "months"),
        checkout_payment_id: 'operator_set',
        checkout_name: 'OPERATOR',
        is_post_sale: false,
        em_id: null
    });
    const [fccDate, setFCCDate] = React.useState({
        fc_id:'',
        visible:false,
        timestamp: moment().subtract(1, "months")
    });
    return <React.Fragment>
        <TableV2
            header={
                <Header title="Order List"
                    childHeight={125}>
                    {<TableFilter schema={'order_info_filter'} fetch={fetchData}/>}
                </Header>
            }
            minColumnWidth={200}
            //maxColumnWidth={400}
            fetchConfig={async (schema) => {
                const {data= {}} = await getFeConfig(schema)
                const { statusCode, rows = [], fields = [] } = data;

                const {REACT_APP_DEMO_MODE = undefined} = process.env;
                if (REACT_APP_DEMO_MODE) {
                    rows.unshift({
                        name: "id",
                        title: "Test Actions",
                        width: 140,
                        minWidth: 140,
                        fixed: 'left',
                        formatter: (row, index, name, type, formatted, value) => {
                            const {id: orderId, fc_id, order_status, sale_type, em_id} = row;
                            const isConfirmed = (order_status === 'fc_confirmed' || order_status === 'payment_rejected');
                            const isPostSale = (sale_type === 'POST_SALE' || sale_type === 'POST_SALE_WITHOUT_LC');
                            const isOnlyAccepted = (order_status === 'accepted');
                            return <Space>
                                <Button disabled={isOnlyAccepted} onClick={()=>{
                                    setFCCDate({
                                        fc_id:`${fc_id}`,
                                        visible: true,
                                        timestamp: moment().subtract(1, "months")
                                    })
                                }}>Update FCC Date</Button>

                                <Button disabled={!(isConfirmed || isPostSale)} onClick={()=>{
                                    setPaid({
                                        id:`${orderId}`,
                                        visible: true,
                                        payment_verified_date: moment().subtract(1, "months"),
                                        checkout_payment_id: `operator_set_${orderId}`,
                                        checkout_name: 'OPERATOR',
                                        is_post_sale: isPostSale,
                                        em_id: em_id
                                    })
                                }}>Mark As Paid</Button>
                            </Space>
                        }
                    })
                }

                rows.unshift({
                    dataIndex: "id",
                    title: "Discount Items",
                    width: 120,
                    minWidth: 120,
                    fixed: 'left',
                    formatter: (row, index, name, type, formatted, value) => {
                        return <Button key={'btn'} onClick={async () => {
                            Modal.info({
                                title: `Discount Items`,
                                content: <React.Fragment>
                                    <OrderDiscountItems order_id={row.id} timestamp_year={row.timestamp_year}/>
                                </React.Fragment>,
                                okType: "ghost",
                                okText: "Close",
                                maskClosable: true,
                                closable: true,
                                keyboard: true,
                                icon: <DropboxOutlined/>,
                                bodyStyle: {overflowX: 'scroll', overflowY: 'scroll', width: 'fit-content', height: '75vh', maxWidth: '75vw'},
                                width: 'fit-content'
                            })
                        }}>Items</Button>
                    }
                })

                rows.unshift({
                    name: "id",
                    title: "Order breakdown",
                    width: 260,
                    minWidth: 260,
                    fixed: 'left',
                    formatter: (row, index, name, type, formatted, value) => {
                        return <Space key={index}>
                            <Button onClick={()=>{
                                setOpt({orderId: value,type: ModalType.Items})
                            }}>Items</Button>
                            <Button onClick={()=>{
                                setOpt({orderId: value,type: ModalType.Splits})
                            }}>Splits</Button>
                            <Button onClick={()=>{
                                setOpt({orderId: value,type: ModalType.Shipments})
                            }}>Shipments</Button>
                        </Space>;
                    }
                }
            );



            const s26Code = rows.find(row => row.name === 's26_code');
            if (s26Code) {
                s26Code.formatter = (row, index, name, type, formatted, value) =>{
                    return value ? `${value}`.replace(/^(\S{4})(\S{5})(\S{2})(\S{2})(\S{4})(\S{4})(\S{2})/g, '$1 $2 $3 $4 $5 $6 $7') : '';
                };
            }
            return {data:{statusCode, rows, fields}};
            }}
            schema={"order_info"}
            fetchData={async (request) => {
                return await fetchData(request.options.filter || {}, request.page)
            }}
            scroll={{x: 'max-content',y:'calc(100vh - 125px - 64px - 50px - 62px - 70px)'}}
        />
        {opt.orderId && <Modal title={`Order #${opt.orderId} ${opt.type === ModalType.Splits ? "Splits" : opt.type === ModalType.Shipments ? "Shipments" : "Items"}`}
                width="80vw"
                visible={opt.type !== ModalType.None}
                closable={true}
                key={opt}
                footer={null}
                onCancel={() => {
                    setOpt({type: ModalType.None, orderId: undefined})
                }}
        >
            {opt.type === ModalType.Items && <Items key={opt} orderId={opt.orderId}/>}
            {opt.type === ModalType.Splits && <Splits key={opt} orderId={opt.orderId}/>}
            {opt.type === ModalType.Shipments && <Shipment key={opt} orderId={opt.orderId}/>}
        </Modal>}

        <Modal
            centered={true}
            closable={true}
            onCancel={()=>setFCCDate({
                fc_id: '',
                visible: false,
                timestamp: moment().subtract(1, "months")
            })}
            visible={fccDate.visible}
            title={`Mark as Paid - Order #${fccDate.fc_id}`}
            onOk={async ()=>{
                const {visible, ...args} = fccDate;
                const {status} = await testUpdateFCCDate({...args});
                if (status === 200) {
                    notification.success({message: `FCC date for FC-ID ${fccDate.fc_id} updated`});
                } else {
                    notification.error({message: `Error updating FCC date for FC-ID ${fccDate.fc_id}.`});
                }
                setFCCDate({
                    fc_id:'',
                    visible:false,
                    timestamp: moment().subtract(1, "months")
                })
            }}
        >
            Note: Use this is for FC Mode/EM Interim report testing purposes only. (timestamp_year is not updated)
            <table>
                <tr style={{paddingBottom: 10}}>
                    <td style={{padding: 12}}><Typography.Text>FC Confirmed Date</Typography.Text></td>
                    <td style={{padding: 12}}><DatePicker value={fccDate.timestamp} onChange={(date)=>{
                        setFCCDate({...fccDate, timestamp: date})
                    }}/></td>
                </tr>
            </table>
        </Modal>

        <Modal
            centered={true}
            closable={true}
            onCancel={()=>setPaid({
                id: '',
                visible: false,
                payment_verified_date: moment().subtract(1, "months"),
                checkout_payment_id: 'operator_set',
                checkout_name: 'OPERATOR',
                is_post_sale: false
            })}
            visible={paid.visible}
            title={`Mark as Paid - Order #${paid.id}`}
            onOk={async ()=>{
                const {visible, is_post_sale, ...args} = paid;
                let res;
                if (is_post_sale) {
                    res = await testUpdatePostSalePaymentDate({...args});
                } else {
                    res = await testVerifyPayment({...args});
                }

                const {status} = res;
                if (status === 200) {
                    notification.success({message: `Order #${paid.id} marked as Paid`});
                } else {
                    notification.error({message: `Error setting Order #${paid.id} as Paid`});
                }
                setPaid({
                    id:'',
                    visible:false,
                    payment_verified_date: moment().subtract(1, "months"),
                    checkout_payment_id: 'operator_set',
                    checkout_name: 'OPERATOR',
                    is_post_sale: false
                })
            }}
        >
            <table>
                <tr style={{paddingBottom: 10}}>
                    <td style={{padding: 12}}><Typography.Text>Payment Verified Date</Typography.Text></td>
                    <td style={{padding: 12}}><DatePicker value={paid.payment_verified_date} onChange={(date)=>{
                        setPaid({...paid, payment_verified_date: date})
                    }}/></td>
                </tr>
                <tr>
                    <td style={{padding: 12}}><Typography.Text>Checkout Payment ID</Typography.Text></td>
                    <td style={{padding: 12}}><Input value={paid.checkout_payment_id} onChange={(e)=>{
                        setPaid({...paid, checkout_payment_id: e.target.value})
                    }}/></td>
                </tr>
            </table>
        </Modal>
    </React.Fragment>
};
